"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckout = exports.CheckoutProvider = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useBasket = require("../commerce-api/custom/hooks/useBasket");
var _useCustomer = require("../commerce-api/custom/hooks/useCustomer");
var _useEinstein = require("../commerce-api/custom/hooks/useEinstein");
var _contexts = require("../commerce-api/contexts");
var _utils = require("../utils/utils");
var _url = require("../utils/url");
var _useMultiSite = require("../hooks/use-multi-site");
var _creditCardUtils = require("../utils/creditCardUtils");
const _excluded = ["id", "preferred", "creationDate", "lastModified", "addressId", "addressName", "useAsBilling"],
  _excluded2 = ["id", "preferred", "creationDate", "lastModified", "addressId", "addressName"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
// @ts-ignore
const CheckoutContext = /*#__PURE__*/_react.default.createContext();
const CheckoutProvider = ({
  children
}) => {
  const mounted = (0, _react.useRef)();
  const api = (0, _contexts.useCommerceAPI)();
  const customer = (0, _useCustomer.useCustomer)();
  const basket = (0, _useBasket.useBasket)();
  const {
    buildUrl
  } = (0, _useMultiSite.useMultiSite)();
  const einstein = (0, _useEinstein.useEinstein)();
  const [state, setState] = (0, _react.useState)({
    // @TODO: use contants to represent checkout steps like const CHECKOUT_STEP_2_SHIPPING = 2
    step: undefined,
    isGuestCheckout: false,
    shippingMethods: undefined,
    paymentMethods: undefined,
    globalError: undefined,
    sectionError: undefined
  });
  const CheckoutSteps = {
    Login_Registration: -1,
    Shipping_Address: 0,
    Shipping_Options: 1,
    Payment: 2,
    Review_Order: 3
  };
  const getCheckoutStepName = step => {
    return Object.keys(CheckoutSteps).find(key => CheckoutSteps[key] === step);
  };

  // @ts-ignore
  const mergeState = (0, _react.useCallback)(data => {
    // If we become unmounted during an async call that results in updating state, we
    // skip the update to avoid React errors about setting state in unmounted components.
    if (!mounted.current) {
      return;
    }
    setState(_state => _objectSpread(_objectSpread({}, _state), data));
  });

  // We use this to track mounted state.
  (0, _react.useEffect)(() => {
    // @ts-ignore
    mounted.current = true;
    return () => {
      // @ts-ignore
      mounted.current = false;
    };
  }, []);
  (0, _react.useEffect)(() => {
    var _basket$customerInfo;
    if (customer.isRegistered && state.isGuestCheckout) {
      mergeState({
        isGuestCheckout: false
      });
    }
    if (customer.isGuest && (_basket$customerInfo = basket.customerInfo) !== null && _basket$customerInfo !== void 0 && _basket$customerInfo.email && !state.isGuestCheckout) {
      mergeState({
        isGuestCheckout: true
      });
    }
    // Derive the starting step for checkout based on current state of basket.
    // A failed condition sets the current step and returns early (order matters).
    if (customer.customerId && basket.basketId && (state.step == undefined || state.step === -2)) {
      var _basket$shipments$, _basket$shipments$2;
      if (customer.isGuest) {
        mergeState({
          step: CheckoutSteps.Login_Registration
        });
        return;
      }
      if (basket.shipments && !((_basket$shipments$ = basket.shipments[0]) !== null && _basket$shipments$ !== void 0 && _basket$shipments$.shippingAddress)) {
        mergeState({
          step: CheckoutSteps.Shipping_Address
        });
        return;
      }
      if (basket.shipments && !((_basket$shipments$2 = basket.shipments[0]) !== null && _basket$shipments$2 !== void 0 && _basket$shipments$2.shippingMethod)) {
        mergeState({
          step: CheckoutSteps.Shipping_Options
        });
        return;
      }
      if (basket.openPaymentAmount !== 0 || !basket.billingAddress || (basket.paymentInstruments || []).length === 0) {
        basket.removePaymentInstrument().then(() => {
          mergeState({
            step: basket !== null && basket !== void 0 && basket.wrongSelectedShipmentMethod ? CheckoutSteps.Shipping_Options : CheckoutSteps.Payment
          });
        });
        return;
      }
      mergeState({
        step: CheckoutSteps.Review_Order
      });
    }
  }, [customer, basket]);

  /**************** Einstein ****************/
  // Run this once when checkout begins
  (0, _react.useEffect)(() => {
    if (basket && basket.productItems && state.step !== -1 && state.step !== -2) {
      einstein.sendBeginCheckout(basket);
    }
  }, []);

  // Run this every time checkout steps change
  (0, _react.useEffect)(() => {
    if (state.step && state.step !== -1 && state.step !== -2) {
      einstein.sendCheckoutStep(getCheckoutStepName(state.step), state.step, basket);
    }
  }, [state.step]);
  const scrollStepIntoView = step => {
    const currentStep = document.getElementById(`step-${step}`);
    if (currentStep) {
      // @ts-ignore
      currentStep.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // We combine our state and actions into a single context object. This is much more
  // convenient than having to import and bind actions seprately. State updates will
  // cause this object to be reinitialized, which may lead to unecesary rerenders,
  // however, the performance impact is negligible/non-existent. If performance
  // becomes an issue later on, further steps may be taken to optimize it.
  const ctx = _react.default.useMemo(() => {
    return _objectSpread(_objectSpread({}, state), {}, {
      // Getter functions
      // Provides convenient access to various data points and derivations.
      // ----------------

      get customer() {
        return customer;
      },
      get basket() {
        return basket;
      },
      get selectedShippingAddress() {
        return basket.shipments && basket.shipments[0].shippingAddress;
      },
      get selectedShippingMethod() {
        return basket.shipments && basket.shipments[0].shippingMethod;
      },
      get selectedPayment() {
        const paymentInstrument = ((basket === null || basket === void 0 ? void 0 : basket.paymentInstruments) || []).find(pi => pi.paymentMethodId !== 'GIFT_CERTIFICATE');
        return paymentInstrument;
      },
      get selectedBillingAddress() {
        return basket.billingAddress;
      },
      get isBillingSameAsShipping() {
        if (!ctx.selectedShippingAddress || !ctx.selectedBillingAddress && ctx.selectedShippingAddress) {
          return false;
        }
        const result = (0, _utils.isMatchingAddress)(ctx.selectedBillingAddress, ctx.selectedShippingAddress);
        return result;
      },
      get checkoutSteps() {
        return CheckoutSteps;
      },
      // Local state setters
      // Callbacks/functions for setting local state data
      // ----------------

      goToNextStep() {
        // @ts-ignore
        const nextStep = state.step + 1;
        mergeState({
          step: nextStep
        });
        scrollStepIntoView(nextStep);
      },
      setCheckoutStep(step) {
        mergeState({
          step
        });
        if (step !== -1) {
          scrollStepIntoView(step);
        }
      },
      setIsGuestCheckout(isGuestCheckout) {
        mergeState({
          isGuestCheckout
        });
      },
      resetGlobalError() {
        mergeState({
          globalError: undefined
        });
      },
      // Async functions
      // Convenience methods for interacting with remote customer and basket data.
      // ----------------

      /**
       * Logs in a registered customer or applies a guest email to basket.
       * @param {Object} credentials
       */
      login({
        email,
        password
      }) {
        return (0, _asyncToGenerator2.default)(function* () {
          if (!password) {
            yield basket.updateCustomerInfo({
              email
            });
          } else {
            yield customer.login({
              email,
              password
            });
          }
        })();
      },
      /**
       * Applies the given address to the basket's shipment. Accepts CustomerAddress and OrderAddress.
       * @see {@link https://salesforcecommercecloud.github.io/commerce-sdk-isomorphic/modules/shoppercustomers.html#customeraddress}
       * @see {@link https://salesforcecommercecloud.github.io/commerce-sdk-isomorphic/modules/shoppercustomers.html#orderaddress}
       * @param {Object} addressData
       */
      setShippingAddress(addressData, currentCountryCode) {
        return (0, _asyncToGenerator2.default)(function* () {
          const {
              id,
              preferred,
              creationDate,
              lastModified,
              addressId,
              addressName,
              useAsBilling
            } = addressData,
            address = (0, _objectWithoutProperties2.default)(addressData, _excluded);
          yield basket.setShippingAddress(address, useAsBilling || false);

          // Add/Update the address to the customer's account if they are registered.
          if (!state.isGuestCheckout) {
            !addressId ? customer.addSavedAddress(address) : customer.updateSavedAddress(_objectSpread(_objectSpread({}, address), {}, {
              addressId: addressId
            }));
          }
        })();
      },
      /**
       * Removes a customer's saved address from their account.
       * @param {string} addressId - The name/identifier of the address to be removed
       */
      removeSavedAddress(addressId) {
        return (0, _asyncToGenerator2.default)(function* () {
          yield customer.removeSavedAddress(addressId);
        })();
      },
      /**
       * Gets the applicable shipping methods for the basket's items and stores it in local state.
       */
      getShippingMethods() {
        return (0, _asyncToGenerator2.default)(function* () {
          const shippingMethods = yield basket.getShippingMethods();
          mergeState({
            shippingMethods
          });
        })();
      },
      /**
       * Sets the shipment's shipping method on the basket.
       * @param {string} id - The shipping method id from applicable shipping methods
       */
      setShippingMethod(id) {
        return (0, _asyncToGenerator2.default)(function* () {
          yield basket.setShippingMethod(id);
        })();
      },
      /**
       * Update the shipment on the basket
       * @param {object} body - The update attributes as object
       */
      updateShipment(body = {}) {
        return (0, _asyncToGenerator2.default)(function* () {
          yield basket.updateShipment(body);
        })();
      },
      /**
       * Gets the applicable payment methods for the order.
       */
      getPaymentMethods() {
        return (0, _asyncToGenerator2.default)(function* () {
          const paymentMethods = // @ts-ignore
          yield api.shopperBaskets.getPaymentMethodsForBasket({
            parameters: {
              basketId: basket.basketId,
              // @ts-ignore
              successUrl: (0, _url.absoluteUrl)(buildUrl('/checkout/confirmation')),
              // @ts-ignore
              failureUrl: (0, _url.absoluteUrl)(buildUrl('/cart'))
            }
          });
          mergeState({
            paymentMethods
          });
        })();
      },
      /**
       * Applies the given payment instrument to the basket.
       * @see {@link https://salesforcecommercecloud.github.io/commerce-sdk-isomorphic/modules/shoppercustomers.html#orderpaymentinstrument}
       * @param {Object} payment
       */
      setPayment(payment) {
        return (0, _asyncToGenerator2.default)(function* () {
          const {
            PaymentMethodRadioGroup,
            SavedPaymentMethodRadioGroup
          } = payment;
          const birthday = payment.DebitCardBirthday || payment.InvoiceSecureBirthday;

          // @ts-ignore
          const failureUrl = (0, _url.absoluteUrl)(buildUrl('/cart'));
          // @ts-ignore
          const successUrl = (0, _url.absoluteUrl)(buildUrl('/checkout/confirmation'));
          let paymentInstrument = {
            paymentMethodId: PaymentMethodRadioGroup
          };
          if (!SavedPaymentMethodRadioGroup || SavedPaymentMethodRadioGroup === 'new') {
            switch (PaymentMethodRadioGroup) {
              case 'HEIDELPAY_NO_PAY':
                break;
              case 'HEIDELPAY_INVOICE':
                break;
              case 'HEIDELPAY_INVOICE_SECURE':
                // @ts-ignore
                paymentInstrument.c_birthday = birthday;
                break;
              case 'HEIDELPAY_DIRECT_DEBIT_SECURE':
                // @ts-ignore
                paymentInstrument.c_birthday = birthday;
                // @ts-ignore
                paymentInstrument.c_bankAccountCountry = payment.DebitCardIBAN.substring(0, 2);
                // @ts-ignore
                paymentInstrument.bank_routing_number = payment.DebitCardBIC;
                // @ts-ignore
                paymentInstrument.payment_bank_account = {
                  holder: payment.DebitCardName,
                  number: payment.DebitCardIBAN
                };
                break;
              case 'HEIDELPAY_PAYPAL':
                // @ts-ignore
                paymentInstrument.c_failureUrl = failureUrl;
                // @ts-ignore
                paymentInstrument.c_successUrl = successUrl;
                break;
              case 'HEIDELPAY_CREDIT_CARD':
                try {
                  const iframeEl = document.getElementById('HEIDELPAY_CREDIT_CARD');
                  const targetOrigin = (0, _creditCardUtils.getIframeOrigin)(
                  // @ts-ignore
                  iframeEl.getAttribute('src'));
                  const customerValues = (0, _creditCardUtils.getCreditCardCustomerValues)(basket, customer);
                  const messageData = yield (0, _creditCardUtils.submitCreditCardForm)(
                  // @ts-ignore
                  iframeEl, customerValues, targetOrigin);
                  if (messageData) {
                    // @ts-ignore
                    paymentInstrument.paymentCard = {
                      // @ts-ignore
                      cardType: messageData.cardType,
                      // @ts-ignore
                      expirationMonth: messageData.expirationMonth,
                      // @ts-ignore
                      expirationYear: messageData.expirationYear,
                      // @ts-ignore
                      holder: messageData.holder,
                      // @ts-ignore
                      number: messageData.number
                    };
                    // @ts-ignore
                    paymentInstrument.c_failureUrl = failureUrl;
                    // @ts-ignore
                    paymentInstrument.c_successUrl = successUrl;
                  } else {
                    throw new Error('CreditCard Error.');
                  }
                } catch (err) {
                  throw new Error(err);
                }
                break;
              default:
                throw new Error('Unexpected error on payment selection.');
                break;
            }
          } else {
            // @ts-ignore
            paymentInstrument.customerPaymentInstrumentId = SavedPaymentMethodRadioGroup;
            switch (PaymentMethodRadioGroup) {
              case 'HEIDELPAY_PAYPAL':
                // @ts-ignore
                paymentInstrument.c_failureUrl = failureUrl;
                // @ts-ignore
                paymentInstrument.c_successUrl = successUrl;
                break;
              case 'HEIDELPAY_CREDIT_CARD':
                // @ts-ignore
                paymentInstrument.c_failureUrl = failureUrl;
                // @ts-ignore
                paymentInstrument.c_successUrl = successUrl;
                break;
              default:
                break;
            }
          }
          yield basket.setPaymentInstrument(paymentInstrument);
        })();
      },
      /**
       * Removes the currently applied payment instrument from the basket. Multiple payment
       * instruments can be applied to the basket, however we are only dealing with one.
       */
      removePayment() {
        return (0, _asyncToGenerator2.default)(function* () {
          yield basket.removePaymentInstrument();
        })();
      },
      /**
       * Applies the given address to the basket's billing address. Accepts CustomerAddress and OrderAddress.
       * @see {@link https://salesforcecommercecloud.github.io/commerce-sdk-isomorphic/modules/shoppercustomers.html#customeraddress}
       * @see {@link https://salesforcecommercecloud.github.io/commerce-sdk-isomorphic/modules/shoppercustomers.html#orderaddress}
       * @param {Object} addressData
       */
      setBillingAddress(addressData) {
        return (0, _asyncToGenerator2.default)(function* () {
          const {
              id,
              preferred,
              creationDate,
              lastModified,
              addressId,
              addressName
            } = addressData,
            address = (0, _objectWithoutProperties2.default)(addressData, _excluded2);
          yield basket.setBillingAddress(address);

          // Save the address to the customer's account if they are registered and its a new address
          if (!state.isGuestCheckout && !id && !addressId) {
            customer.addSavedAddress(address);
          }
        })();
      },
      placeOrder() {
        return (0, _asyncToGenerator2.default)(function* () {
          mergeState({
            globalError: undefined
          });
          try {
            return yield basket.createOrder();
          } catch (error) {
            basket.getOrCreateBasket();
            // @ts-ignore
            mergeState({
              globalError: error.message
            });
            throw error;
          }
        })();
      }
    });
  }, [state, customer, basket, mergeState]);
  return /*#__PURE__*/_react.default.createElement(CheckoutContext.Provider, {
    value: ctx
  }, children);
};
exports.CheckoutProvider = CheckoutProvider;
CheckoutProvider.propTypes = {
  children: _propTypes.default.any
};
/**
 * A hook for managing checkout state and actions
 * @returns {Object} Checkout data and actions
 */
const useCheckout = () => {
  return _react.default.useContext(CheckoutContext);
};
exports.useCheckout = useCheckout;